import {
  getTransactionChart,
  getTransactionReconciliation,
} from "../../helpers/jwt_helper";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_TRANSACTION_CHART,
  GET_TRANSACTION_RECONCILIATION,
} from "./actionTypes";
import {
  setReconciliationLoader,
  setTransactionReconciliation,
  setTransactionsChart,
} from "./actions";

function* onGetTransactionReconciliation({ payload: params }) {
  try {
    yield put(setReconciliationLoader());
    const response = yield call(getTransactionReconciliation, { ...params });
    let data = { ...response };
    if (data?.transactions.length > 0) {
      data.transactions = [
        {
          type: "BALANCE",
          label: `Balance for ${response.start_date}`,
          start_balance: response.start_balance,
        },
        ...response.transactions,
      ];
    }
    yield put(setTransactionReconciliation(data));
    yield put(setReconciliationLoader());
  } catch (error) {
    console.log(error);
    yield put(setReconciliationLoader());
  }
}

function* onGetTransactionsChart({ payload: data }) {
  try {
    const response = yield call(getTransactionChart, { ...data });
    let resSort = {
      labels: [],
      items: [
        {
          name: "Balance",
          type: "column",
          data: [],
        },
        {
          name: "Credit",
          type: "area",
          data: [],
        },
        {
          name: "Debit",
          type: "line",
          data: [],
        },
      ],
    };
    for (let [it, val] of Object.entries(response)) {
      resSort.labels.push(it);
      if (val.balance) resSort.items[0].data.push(val.balance || 0);
      if (val.credit) resSort.items[1].data.push(val.credit || 0);
      if (val.debit) resSort.items[2].data.push(val.debit || 0);
    }

    // 2022-09 : {debit: 26110, credit: 25663, balance: 447}
    // 2022-10: {debit: 6100, credit: 7920, balance: -1373}
    // 2022-11: {debit: 12405, credit: 10605, balance: 427}
    // 2022-12: {debit: 12666, credit: 12500, balance: 593}

    // {
    //   name: "Team A",
    //   type: "column",
    //   data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
    // },
    // {
    //   name: "Team B",
    //   type: "area",
    //   data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
    // },
    // {
    //   name: "Team C",
    //   type: "line",
    //   data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
    // },
    yield put(setTransactionsChart(resSort));
  } catch (e) {
    console.log(e);
  }
}

function* transactionsSaga() {
  yield takeEvery(
    GET_TRANSACTION_RECONCILIATION,
    onGetTransactionReconciliation
  );
  yield takeEvery(GET_TRANSACTION_CHART, onGetTransactionsChart);
}

export default transactionsSaga;
